import { useMediaQuery } from "@mui/material";
// should be wrapped around components that can only be viewed
// on tablets and phones
export default function MobileViewer({ children }) {
  const isMobile = useMediaQuery("(max-width: 768px)");
  return isMobile ? children : null;
}
